//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed } from '@nuxtjs/composition-api';
import MoominHeaderSearchSuggestionsRow from './MoominHeaderSearchSuggestionsRow.vue';

export default {
    name: "MoominHeaderSearchSuggestions",
    components: {
      MoominHeaderSearchSuggestionsRow
    },
    props: {
        topSearchesText: {
            type: String,
            default: "Top searches"
        },
        searchSuggestionsText: {
            type: String,
            default: "Search suggestions"
        },
        noResultsText: {
          type: String,
          default: "No suggestion found."
        },
        searchSuggestions: {
            type: Array,
            default: () => []
        },
        topSearches: {
            type: Array,
            default: () => []
        },
        searchTerm: {
            type: String,
            required: true,
            default: ''
        },
        searchIconAlt: {
          type: String,
          default: 'Search icon'
        }
    },
    setup(props) {
        const activeLabel = computed(() => props.searchTerm ? props.searchSuggestionsText : props.topSearchesText);
        const activeSearchSuggestions = computed(() => props.searchTerm ? props.topSearches : props.searchSuggestions);
        const returnSearchIconAlt = (suggestion) => `${props.searchIconAlt}-${suggestion}`;

        return {
            activeLabel,
            activeSearchSuggestions,
            returnSearchIconAlt
        };
    },
};
